import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Button,
  Col,
  Divider,
  Input,
  Row,
  Select,
  Alert,
} from "antd";
import DeleteIcon from "@mui/icons-material/Delete";
import AuthService from "../../../Components/auth/AuthService";
import config from "../../../Components/config";
import dayjs from "dayjs";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton, IconButton } from "@mui/material";
import {  FieldTimeOutlined, ProductOutlined, SnippetsOutlined } from "@ant-design/icons";
import qs from "query-string";
import { hideLoading, showLoading, useLoadingDispatch } from "../../../context/loadingContext";
import { useNavigate, useParams } from "react-router-dom";
import { HelperReminderTasks } from "../../../Components/common/Constants";
import { showMessage } from "../../../Components/Utils/message";
import FormGrid from "../../../Components/common/FormGrid";
import InputBox from "../../../Components/common/InputBox";
import { decodeId } from "../../../Components/common/CommonFun";


const Auth = new AuthService();

const ResolveHelperReminder = () => {

  const navigate = useNavigate()
  const params = useParams();
    const decodedID = decodeId(params?.id)

  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  var layoutDispatch = useLoadingDispatch();

  const currentDate = dayjs()
  const [selectedHelper, setSelectedHelper] = React.useState(null);
  const [selectedTask, setSelectedTask] = React.useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [dueDateNext, setDueDateNext] = useState(null);
  const [completionDate, setCompletionDate] = useState(currentDate);
  const [thresholdDays, setThresholdDays] = useState('');

  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [notes, setNotes] = React.useState("");
  const [currentRecord, setCurrentRecord] = React.useState("");


  const [allHelpers, setAllHelpers] = React.useState([]);


  const getAllHelpers = async () => {
       showLoading(layoutDispatch);
       try {
         const response = await Auth.fetch(`/helper/warehouse-helpers`);
         if (response) {
           hideLoading(layoutDispatch);
           if (response?.ack) {
             setAllHelpers(response.warehouse_helpers);
           }
         }
       } catch (err) {
         console.log(err);
       }
     }

  useLayoutEffect(()=> {
    getAllHelpers()
  },[])


  const getDataByID = async () => {
    showLoading(layoutDispatch)
    try {
        const res = await Auth.fetch(`/warehouse-helper-reminder/reminder-warehouse-helper?id=${id}`)
        if(res?.ack) {
            setSelectedHelper(res?.reminder?.warehouse_helper_id);
            setSelectedTask(res?.reminder?.type)
            setDueDate(res?.reminder?.due_date ? dayjs(res?.reminder.due_date, 'YYYY-MM-DD') : null)
            setCurrentItemFiles(res?.reminder?.files ? JSON.parse(res?.reminder?.files) : [])
            setNotes(res?.reminder?.notes || '')
            setCurrentRecord(res?.reminder)
        }
    } catch (err) {
        console.log(err);
    } finally {
        hideLoading(layoutDispatch)
    }
  }

  useEffect(()=>{
    if(id > 0) {
    getDataByID()
    }
  },[])



useEffect(() => {
    if (selectedTask && completionDate) {
      const interval = HelperReminderTasks.filter((item)=> item.id === selectedTask);
      if (interval) {
        const nextDueDate = dayjs(completionDate).add(interval[0].interval || 0, interval[0].intervalType);
        setDueDateNext(nextDueDate.toDate());
        setThresholdDays(interval[0].thresholdDays)
      }
    }
  }, [selectedTask, completionDate]);  


  const handleOk = async () => {
    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    if(isEmptyOrUndefined(completionDate)) {
    showMessage('error','Please enter completion date')
    return;
    }
    showLoading(layoutDispatch);
    const dataToSend = {
      reminder : currentRecord, 
      files: currentItemFiles,
      notes: notes,
      next_due_date: dueDateNext ? dayjs(dueDateNext).format('YYYY-MM-DD') : null,
      completion_date: completionDate ? dayjs(completionDate).format('YYYY-MM-DD') : null
    }
    try {
      const res = await Auth.fetch("/warehouse-helper-reminder/resolve-reminder-warehouse-helper", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      })
      if(res?.ack) {    
        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, id)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);    
        showMessage('success',res?.message)
        navigate('/helper_reminder')
      } else {
        showMessage('error',res?.message)
      }

    } catch (err) {
      console.log(err);
    } 
    finally {
    hideLoading(layoutDispatch);
    }
  };

  const getThresholdDisplay = (thresholdDays) => {
    const weeks = thresholdDays / 7;
    const months = thresholdDays / 30;
  
    if (Number.isInteger(weeks)) {
      return `${weeks} week${weeks > 1 ? 's' : ''}`;
    } else if (Number.isInteger(months)) {
      return `${months} month${months > 1 ? 's' : ''}`;
    } else {
      return `${thresholdDays} day${thresholdDays > 1 ? 's' : ''}`;
    }
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${
        file.name.split(".")[1]
      }`;
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const getUploadUrl = async (file, recordID) => {
    const params = {
      bucket: config.wms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/warehouse-reminders-helper/" + recordID + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };

  const formItems = [
       {
              label: "Helper",
              value: selectedHelper,
              options: allHelpers,
              onChange: (val) => setSelectedHelper(val ),
              icon: <ProductOutlined style={{ color: "#722ed1"}}/>,
              readOnly: true,
              type: 'select',
              data: 'helpers',
            },
            {
              label: "Tasks",
              value: selectedTask,
              options: HelperReminderTasks,
              onChange: (val) => setSelectedTask(val),
              icon: <ProductOutlined style={{ color: "#1677ff"}}/>,
              readOnly: true,
              type: 'select',
              data: 'constants',
            },
            {
              label: "Due Date",
              value: dueDate,
              onChange: (date) => { setDueDate(date ? dayjs(date, 'YYYY-MM-DD') : null) },
              icon: <FieldTimeOutlined style={{ color: "#1677ff"}}/>,
              readOnly: true,
              type: 'date',
              disabledDate: disabledDate
            },
            {
              label: "Compeletion Date",
              value: completionDate,
              onChange: (date) => { setCompletionDate(date ? dayjs(date, 'YYYY-MM-DD') : null) },
              icon: <FieldTimeOutlined style={{ color: "#1677ff"}}/>,
              readOnly: false,
              type: 'date',
            },
    ]
  
    const notesItem = {
              label: 'Notes',
              value: notes,
              onChange: (val) => setNotes(val),
              type: 'notes',
              icon: <SnippetsOutlined  style={{ color: "#1677ff"}}/>
      };

  return (
    <>
      <div>
      <div>
            <h3>Resolve Helper Reminder</h3>
        </div>
        <FormGrid formItems={formItems}/>
        <>
          {/* <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Helper<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              disabled
              value={selectedHelper}
              placeholder="Please Select"
              onChange={(value) => {
                setSelectedHelper(value);
              }}
            >
              {allHelpers.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.first_name}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Tasks<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              disabled
              value={selectedTask}
              placeholder="Please Select"
              onChange={(value) => {
                setSelectedTask(value);
              }}
            >
              {HelperReminderTasks.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.title}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Due Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
            </span>
            <DatePicker
              format={"DD-MM-YYYY"}
              disabled
              value={dueDate}
              style={{
                width: "100%",
              }}
              placeholder="Select date"
            />
            </Col>
            
          </Row>
          <Row style={{marginTop: '5px'}} gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
             Completion Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
            </span>
            <DatePicker
              format={"DD-MM-YYYY"}
              value={completionDate}
              onChange={(date) => {
                setCompletionDate(date ? dayjs(date, 'YYYY-MM-DD') : null);
              }}
              style={{
                width: "100%",
              }}
              placeholder="Select date"
              // disabledDate={disabledDate}
            />
            </Col>
          </Row> */}
          <Row style={{marginTop: '5px'}} gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            {/* <span>
              Notes:
            </span>
                <TextArea value={notes} onChange={(e)=> setNotes(e.target.value)} autoSize={{ minRows: 3, maxRows: 6 }} /> */}
                <InputBox inputItem={notesItem} inputType={'notes'}/>
            </Col>
          </Row>
          <Divider />
          <>
          <div>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            // onChange={(e) => {
            //   handleSubmitImage(e);
            // }}
            onClick={(e) => {
                        // ensures it always triggers even if same file is picked
                        e.target.value = "";
                    }}
            onChange={(e) => {
                          const myfiles = e.target.files;
                          if (myfiles.length > 10) {
                            showMessage('error',"A maximum of 10 images can be uploaded at a time.");
                            e.target.value = "";
                          } else {
                            handleSubmitImage(e);
                          }
                        }}
          />
        </UploadButton>
      </div>
      {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
      <ul>
                  {currentItemFiles?.length > 0 &&
                    currentItemFiles
                      .filter(
                        (item) =>
                          !files.some((file) => file.name === item)
                      )
                      .map((item) => {
                        const lastHyphenIndex = item.lastIndexOf("-");
                        const dotBeforeExtensionIndex = item.lastIndexOf(".");
                        const newFileName =
                          item.slice(0, lastHyphenIndex) +
                          item.slice(dotBeforeExtensionIndex);
                        return (
                          <li>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={() => handleDeleteCurrentFile(item)}
                                >
                                  <DeleteIcon />
                                </IconButton>

                            <a
                              href={`${config.wms_uploads_cdn}/${config.env}/warehouse-reminders-helper/${id}/${item}`}
                              target="_blank"
                            >
                              {newFileName}
                            </a>
                          </li>
                        );
                      })}
                </ul>
        <Divider />
      {files?.length > 0 && <h4>Files:</h4>}
      <ul>
                  {files.length > 0 &&
                    files.map((files) => {
                      return (
                        <li>
                          {" "}
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteFile(files.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          {files.name}
                        </li>
                      );
                    })}
                </ul>
          </>

          <>
        <Alert 
        description={
        <>
        <span>{`Next Due Date: ${dayjs(dueDateNext).format('DD-MM-YYYY')}  `}</span><br/>
        <span>{`Time Due Soon Threshold: ${getThresholdDisplay(thresholdDays)} `}</span>
        </>
        } 
        type="info" 
        showIcon />
        </>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <Button
            onClick={() => navigate("/helper_reminder")}
            danger
            size="large"
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
            <Button
              type="primary"
              size="large"
              onClick={handleOk}
            >
              Save
            </Button>
        </div>
        </>
      </div>
    </>
  );
};

export default ResolveHelperReminder;
